// Guard für die Übernahme eines Titel-Vorschlags ins Eintrag-Formular:
// Projekt/Tätigkeit der letzten Verwendung NUR in noch leere Felder
// schreiben — eine manuelle Auswahl wird nie überschrieben — und nur, wenn
// die ID in den geladenen Listen existiert (archivierte/gelöschte Einträge
// fallen raus). Spiegel des Last-Used-Prefill-Guards in calendar-timer.tsx.

export interface SuggestionSelection {
  projectId: string | null
  serviceId: string | null
}

export interface SuggestionFillResult {
  projectId?: string
  serviceId?: string
}

export function resolveSuggestionFill(
  suggestion: SuggestionSelection,
  current: { projectId: string; serviceId: string },
  projects: { id: string }[],
  services: { id: string }[],
): SuggestionFillResult {
  const result: SuggestionFillResult = {}
  if (
    current.projectId === '' &&
    suggestion.projectId &&
    projects.some((p) => p.id === suggestion.projectId)
  ) {
    result.projectId = suggestion.projectId
  }
  if (
    current.serviceId === '' &&
    suggestion.serviceId &&
    services.some((s) => s.id === suggestion.serviceId)
  ) {
    result.serviceId = suggestion.serviceId
  }
  return result
}
